import { CrossHairInfoMultiStrikeChart } from './chart.typings'

export type MultiStrikeMetadataDomUpdater = (info: CrossHairInfoMultiStrikeChart | undefined) => void

const updatersByViewKey: Record<string, Set<MultiStrikeMetadataDomUpdater>> = {}

export function registerMultiStrikeMetadataUpdater(viewKey: string, updater: MultiStrikeMetadataDomUpdater) {
    if (!updatersByViewKey[viewKey]) {
        updatersByViewKey[viewKey] = new Set()
    }
    updatersByViewKey[viewKey].add(updater)
    return () => {
        updatersByViewKey[viewKey]?.delete(updater)
        if (updatersByViewKey[viewKey]?.size === 0) {
            delete updatersByViewKey[viewKey]
        }
    }
}

export function applyCrosshairToMultiStrikeMetadataDom(viewKey: string, info: CrossHairInfoMultiStrikeChart | undefined) {
    updatersByViewKey[viewKey]?.forEach((updater) => updater(info))
}

export function clearMultiStrikeMetadataUpdaters(viewKey: string) {
    delete updatersByViewKey[viewKey]
}

export function setSpanTextContent(el: HTMLSpanElement | null, text: string) {
    if (el && el.textContent !== text) {
        el.textContent = text
    }
}
